/* Rewards shop frontend JS — Phase 3+4+5 baseline */

import TomSelect from 'tom-select';

document.addEventListener('DOMContentLoaded', () => {
    initCartTimer();
    initCartPoll();
    initSortSheet();
    initFakeWatchers();
    initCheckoutBackTrap();
    initStoreSelect();
});

/* Cart 5-min reservation timer — counts down to data-expires-at, shows mm:ss */
function initCartTimer() {
    const el = document.getElementById('js-cart-timer');
    if (!el) return;
    const expiresAt = new Date(el.dataset.expiresAt).getTime();
    // Display target — albo dziecko `.js-timer-display` (legacy), albo sam element (cart view)
    const display = el.querySelector('.js-timer-display, .js-cart-timer-display') || el;

    function tick() {
        const secLeft = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
        const mm = String(Math.floor(secLeft / 60)).padStart(2, '0');
        const ss = String(secLeft % 60).padStart(2, '0');
        display.textContent = `${mm}:${ss}`;
        if (secLeft <= 0) {
            showExpiredModal();
            refreshCartState(); // restore + odśwież saldo punktów od razu, bez przeładowania
            clearInterval(handle);
        }
    }
    tick();
    const handle = setInterval(tick, 1000);
}

/* Polls /nagrody/api/koszyk/stan every 20s — handles server-side expiry detection */
function initCartPoll() {
    if (!document.getElementById('js-cart-timer') && !document.getElementById('js-cart-bag-badge')) return;
    setInterval(refreshCartState, 20000);
}

/* Fetches cart state and applies it to the page: bag badge, points balance, expiry modal.
   On expiry the server (CartExpirySubscriber) restores reserved points on this request,
   so the returned userPoints is the up-to-date balance — we reflect it live, no reload. */
async function refreshCartState() {
    try {
        const r = await fetch('/nagrody/api/koszyk/stan', { credentials: 'same-origin' });
        if (!r.ok) return;
        const data = await r.json();
        const badge = document.getElementById('js-cart-bag-badge');
        if (badge) {
            badge.textContent = data.itemCount || 0;
            badge.dataset.count = String(data.itemCount || 0);
        }
        if (typeof data.userPoints === 'number') {
            document.querySelectorAll('.js-rewards-points').forEach((el) => {
                el.textContent = data.userPoints;
            });
        }
        if (data.active === false && data.expired) {
            showExpiredModal();
        }
    } catch (e) { /* network blip, ignore */ }
}

function showExpiredModal() {
    if (document.getElementById('js-rewards-expired-modal')) return;
    const logoSrc = document.body.dataset.logoUrl || '';
    const html = `
        <div class="s-rewards-modal" id="js-rewards-expired-modal" role="dialog" aria-modal="true">
            <div class="s-rewards-modal__card">
                <div class="s-rewards-modal__logo">
                    <img src="${logoSrc}" alt="Sephora Summer Vibes Game On">
                </div>
                <h3 class="s-rewards-modal__title">UWAGA</h3>
                <p class="s-rewards-modal__desc">Czas na odbiór nagrody upłynął.</p>
                <button type="button" class="s-rewards-modal__btn" onclick="window.location.href='/nagrody/katalog'"><span>OK</span></button>
            </div>
        </div>`;
    document.body.insertAdjacentHTML('beforeend', html);
}

/* Sort sheet overlay */
function initSortSheet() {
    const trigger = document.querySelector('[data-sort-trigger]');
    const sheet = document.getElementById('js-sort-sheet');
    const close = document.querySelector('[data-sort-close]');
    if (!trigger || !sheet) return;
    trigger.addEventListener('click', () => sheet.removeAttribute('hidden'));
    close?.addEventListener('click', () => sheet.setAttribute('hidden', ''));
    sheet.addEventListener('click', (e) => {
        if (e.target === sheet) sheet.setAttribute('hidden', '');
    });
}

/* Checkout back-trap — przechwytuje próbę powrotu (link wstecz / browser back),
   pokazuje modal: TAK → POST abandon endpoint i przejście do katalogu; NIE → zostaje. */
function initCheckoutBackTrap() {
    const modal = document.getElementById('js-rewards-back-modal');
    if (!modal) return;

    const backLinks = document.querySelectorAll('.c-game-back, .s-rewards-checkout__btn-secondary');
    const closeBtn = modal.querySelector('[data-back-modal-close]');

    const openModal = () => {
        modal.removeAttribute('hidden');
    };
    const closeModal = () => {
        modal.setAttribute('hidden', '');
    };

    backLinks.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            openModal();
        });
    });

    closeBtn?.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });

    history.pushState({ rewardsBackTrap: true }, '', location.href);
    window.addEventListener('popstate', () => {
        openModal();
        history.pushState({ rewardsBackTrap: true }, '', location.href);
    });
}

/* Wybór sklepu odbioru — przeszukiwalny select (tom-select) z listą sklepów Sephora.
   Pozwala filtrować po nazwie, mieście i numerze sklepu. */
function initStoreSelect() {
    const select = document.querySelector('[data-store-select]');
    if (!select) return;

    new TomSelect(select, {
        maxOptions: null,
        allowEmptyOption: false,
        placeholder: select.dataset.placeholder || 'Wybierz sklep…',
        searchField: ['text'],
        sortField: { field: '$order' },
    });
}

/* Fake "X osób ogląda" — seeded stable random per cart+user+hour */
function initFakeWatchers() {
    document.querySelectorAll('[data-fake-watchers]').forEach((el) => {
        const seed = el.dataset.seed || '';
        let hash = 0;
        for (let i = 0; i < seed.length; i++) {
            hash = ((hash << 5) - hash) + seed.charCodeAt(i);
            hash |= 0;
        }
        const n = 3 + (Math.abs(hash) % 13);
        const counter = el.querySelector('[data-watcher-count]');
        if (counter) counter.textContent = String(n);
    });
}
